/**
 * Callback OAuth de Meta.  (spec 039 · FR-002)
 * Meta redirige aquí con ?code&state; el tesoro vive en el provisioner.
 */
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

import { api, ErrorApi } from '../../lib/api'

export function McpFacebookOauth() {
    const [params] = useSearchParams()
    const navigate = useNavigate()
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const code = params.get('code')
        const state = params.get('state')
        const err = params.get('error')
        if (err) {
            setError(err)
            return
        }
        if (!code || !state) {
            setError('Meta no devolvió code y state')
            return
        }
        const redirectUri = `${window.location.origin}/mcp-facebook/oauth`
        void api
            .post('/mcp-facebook/oauth/callback', { code, state, redirectUri })
            .then(() => navigate('/mcp-facebook', { replace: true }))
            .catch((e: unknown) => {
                setError(e instanceof ErrorApi || e instanceof Error ? e.message : 'OAuth falló')
            })
    }, [params, navigate])

    return (
        <div className="mx-auto max-w-lg space-y-3">
            <h1 className="text-lg font-semibold text-neutral-100">MCP Facebook</h1>
            {error ? (
                <p className="text-sm text-rose-400">{error}</p>
            ) : (
                <p className="text-sm text-neutral-400">Cerrando la sesión con Meta…</p>
            )}
        </div>
    )
}
